module.exports = __webpack_public_path__ + "static/img/CDClogo.c4899891.png";